class JobOffersFilter extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeElements();
    this.initializeJobData();
    this.bindEvents();
  }

  initializeElements() {
    this.form = this.querySelector('[data-js="filter-form"]');
    this.jobList = this.querySelector('[data-js="job-list"]');
    this.rowTemplate = document.getElementById('jobOffersJobRowTemplate');
    this.filterSelects = {
      jobGroup: this.querySelector('[data-js="filter-jobgroup"]'),
      category: this.querySelector('[data-js="filter-category"]'),
      location: this.querySelector('[data-js="filter-location"]'),
    };
  }

  initializeJobData() {
    this.jobs = Array.from(this.jobList.querySelectorAll('tr[data-categories]')).map((row) => ({
      title: row.querySelector('[data-js="job-link"]').textContent,
      link: row.querySelector('[data-js="job-link"]').href,
      location: row.querySelector('[data-js="location-cell"]').textContent,
      categories: row.dataset.categories.split(' '),
    }));
  }

  bindEvents() {
    this.form.addEventListener('change', () => {
      this.updateJobList();
    });
  }

  updateJobList() {
    const activeFilters = this.getActiveFilters();
    const filteredJobs = this.filterJobs(activeFilters);
    this.renderJobs(filteredJobs);
  }

  getActiveFilters() {
    return Object.entries(this.filterSelects).reduce((activeFilters, [filterName, selectElement]) => {
      const selectedValue = selectElement.value;
      if (selectedValue) {
        activeFilters[filterName] = selectedValue;
      }
      return activeFilters;
    }, {});
  }

  filterJobs(activeFilters) {
    if (Object.keys(activeFilters).length === 0) {
      return this.jobs;
    }

    return this.jobs.filter((job) =>
      Object.values(activeFilters).every((filterValue) => job.categories.includes(filterValue)),
    );
  }

  renderJobs(jobsToRender) {
    this.jobList.innerHTML = '';
    jobsToRender.forEach((job) => {
      const newRow = this.createJobRow(job);
      this.jobList.appendChild(newRow);
    });
  }

  createJobRow(job) {
    const row = this.rowTemplate.content.cloneNode(true);
    const link = row.querySelector('[data-js="job-link"]');
    link.href = job.link;
    link.textContent = job.title;

    row.querySelector('[data-js="location-cell"]').textContent = job.location;
    row.querySelector('[data-js="job-row"]').dataset.categories = job.categories.join(' ');

    return row;
  }
}

customElements.define('job-offers-filter', JobOffersFilter);
